import { useEffect } from 'react';
import useExploreData from '../useExploreData/useExploreData';
import ExploreContentCard from 'components/common/ExploreContentCard/ExploreContentCard';
import Spinner from '@core/components/spinner/Spinner';
import LoginPrompt from 'components/common/loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';
import Pagination from '@mui/material/Pagination';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import classes from './ExploreDataWrapper.module.scss';
import ExploreEmptyState from './exploreemptystate/ExploreEmptyState';

const ExploreDataWrapper = ({ selectedPage, handlePageChange, setResultCount }) => {
	const { data, isLoading } = useExploreData();

	const { toast, ToastContainer } = UseToast();
	const {
		show: loginNoticeVisible,
		showModal: loginNoticeShowModal,
		destroyModal: loginNoticeDestroyModal
	} = UseModal();

	useEffect(() => {
		if (data)
			setResultCount(data.data.count);
	}, [data]);

	return (
		<>
			<div className="d-flex flex-column gap-4 w-100">
				{data && !isLoading ? (
					<>
						<div className="d-flex flex-wrap flex-column">
							{data.data.count === 0 ? (
								<ExploreEmptyState />
							) : (
								<>
									{data.data.results.map((content) => (
										<div className={`${classes['explore-data-card-wrapper']} py-4`}>
											<ExploreContentCard
												key={content.id}
												content={content}
												toast={toast}
												loginNoticeShowModal={loginNoticeShowModal}
											/>
										</div>
									))}
								</>
							)}
						</div>
						{data.data.count > 10 && (
							<div className="d-flex align-items-center justify-content-center pb-lg-0 mb-lg-0 mb-5 pb-5">
								<Pagination
									count={Math.ceil(data.data.count / 10)}
									page={selectedPage ? +selectedPage : 1}
									variant="outlined"
									shape="rounded"
									color="primary"
									onChange={(e, page) => {
										handlePageChange(page);
										window.scrollTo(0, 0);
									}}
								/>
							</div>
						)}
					</>
				) : (
					<div className="d-flex align-items-center justify-content-center w-100 py-5">
						<Spinner />
					</div>
				)}
			</div>
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={loginNoticeDestroyModal}
				show={loginNoticeVisible}>
				<div
					className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
					<div className={`d-flex flex-column align-items-center justify-content-center`}>
						<LoginPrompt />
					</div>
				</div>
			</Modal>
			<ToastContainer />
		</>
	);
};

export default ExploreDataWrapper;
